import { createVNode, createComponentVNode, createTextVNode } from "inferno";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import { Component } from 'inferno';
import ValidatedInput from 'dmn-js-shared/lib/components/ValidatedInput';
import { getSampleDate, validateISOString, parseString } from '../Utils';

var OutputDateEdit =
/*#__PURE__*/
function (_Component) {
  _inherits(OutputDateEdit, _Component);

  function OutputDateEdit(props, context) {
    var _this;

    _classCallCheck(this, OutputDateEdit);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(OutputDateEdit).call(this, props, context));
    _this._modeling = context.injector.get('modeling');
    var element = _this.props.context.element;
    var parsedString = parseString(element.businessObject.text);
    _this.state = {
      date: parsedString ? parsedString.date : ''
    };
    var debounceInput = context.injector.get('debounceInput');
    _this.debouncedEditCell = debounceInput(_this.editCell.bind(_assertThisInitialized(_this)));
    _this.editCell = _this.editCell.bind(_assertThisInitialized(_this));
    _this.onClick = _this.onClick.bind(_assertThisInitialized(_this));
    _this.onInput = _this.onInput.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(OutputDateEdit, [{
    key: "editCell",
    value: function editCell(cell, text) {
      this._modeling.editCell(cell, text);
    }
  }, {
    key: "onClick",
    value: function onClick() {
      var element = this.props.context.element;
      var date = getSampleDate();
      this.setState({
        date: date
      });
      this.editCell(element.businessObject, "date and time(\"".concat(date, "\")"));
    }
  }, {
    key: "onInput",
    value: function onInput(_ref) {
      var isValid = _ref.isValid,
          value = _ref.value;

      if (isValid) {
        var element = this.props.context.element;
        this.setState({
          date: value
        });
        this.debouncedEditCell(element.businessObject, "date and time(\"".concat(value, "\")"));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var date = this.state.date;
      return createVNode(1, "div", "context-menu-container simple-date-edit", [createVNode(1, "h3", "dms-heading", createTextVNode("Edit Date"), 2), createVNode(1, "h4", "dms-heading", createTextVNode("Set Date"), 2), createVNode(1, "div", null, [createComponentVNode(2, ValidatedInput, {
        "onInput": this.onInput,
        "placeholder": "e.g. ".concat(getSampleDate()),
        "validate": validateISOString,
        "value": date,
        "className": "dms-block"
      }), createVNode(1, "p", "dms-hint", [createTextVNode("Set date "), createVNode(1, "button", "use-today", createTextVNode("to today"), 2, {
        "type": "button",
        "onClick": this.onClick
      }), createTextVNode(".")], 4)], 4)], 4);
    }
  }]);

  return OutputDateEdit;
}(Component);

export { OutputDateEdit as default };
//# sourceMappingURL=OutputDateEdit.js.map